import { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";

import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import SelectUserEmailInput from "../../inputs/SelectUserEmailInput";

const RffSelectUserEmailField = ({
  name,
  label,
  required = false,
  row = false,
  suppressGrid,
  size,
}) => {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      row={row}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
          <SelectUserEmailInput
            label={label}
            value={input?.value}
            onChange={(v) => {
              input.onChange(v);
            }}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffSelectUserEmailField;
